// extracted by mini-css-extract-plugin
module.exports = {"detail":"MoreDetail_detail__18fWq","root":"MoreDetail_root__1b8Yj","dialog":"MoreDetail_dialog__30_lW","img":"MoreDetail_img__2_Yow","txt":"MoreDetail_txt__1bDUK"};